export const CONSULT_CALL_YES = "Yes";
export const CONSULT_CALL_NO = "No";
export const CONSULT_CALL_I_DONT_KNOW = "I don't know";

export type ConsultCallInputs =
  | typeof CONSULT_CALL_YES
  | typeof CONSULT_CALL_NO
  | typeof CONSULT_CALL_I_DONT_KNOW;
